export default __webpack_public_path__ + "static/media/OpenSeaIcon.65822956.png";